export const messageError = (err: any) => {
  if (err) {
    if (err.status === 500) {
      if (err.data && err.data.messages) return err.data.messages[0]
      else return 'Có lỗi xảy ra'
    } else if (err.status === 404) {
      return 'Không tồn tại api. Thử lại'
    } else if (err.status === 400) {
      if (err.data.errors && err.data.errors.request) return err.data.errors.request[0]
      else if (err.data.errors && err.data.errors.Messages) {
        if (err.data.errors.Messages[0].includes('ORA')) {
          return err.data.errors.Messages[0].substring(
            err.data.errors.Messages[0].indexOf(':') + 1,
            err.data.errors.Messages[0].indexOf('\n')
          )
        } else return err.data.errors.Messages[0]
      } else if (err.data.errors && err.data.errors.deleteObjectInsured)
        return err.data.errors.deleteObjectInsured[0]
      else if (err.data.errors && err.data.errors.deleteContract)
        return err.data.errors.deleteContract[0]
      else return 'Có lỗi xảy ra'
    } else {
      return 'Có lỗi xảy ra'
    }
  }
}
